"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardUserContextClientV2 = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class DashboardUserContextClientV2 extends authenticated_client_1.AuthenticatedClient {
    create(projectId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/users/me/dashboard-user-contexts`, payload);
            return response.payload;
        });
    }
    getById(projectId, dashboardId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/projects/${projectId}/users/me/dashboard-user-contexts/${dashboardId}`);
            return response.payload;
        });
    }
    update(projectId, dashboardId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v2/projects/${projectId}/users/me/dashboard-user-contexts/${dashboardId}`, payload);
            return response.payload;
        });
    }
    updateSeenLast(projectId, dashboardId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v2/projects/${projectId}/users/me/dashboard-user-contexts/${dashboardId}/seen`);
            return response.payload;
        });
    }
    delete(projectId, dashboardId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`/v2/projects/${projectId}/users/me/dashboard-user-contexts/${dashboardId}`);
            return response.payload;
        });
    }
    markAsSeen(projectId, dashboardId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v2/projects/${projectId}/users/me/dashboard-user-contexts/${dashboardId}/mark-as-seen`);
            return response.payload;
        });
    }
    updateStackingStrategy(projectId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v2/projects/${projectId}/users/me/dashboard-user-contexts/apply/segment-stacking`, payload);
            return response.payload;
        });
    }
}
exports.DashboardUserContextClientV2 = DashboardUserContextClientV2;
//# sourceMappingURL=dashboard-user-context.client.v2.js.map